import { ViewState } from 'utils/viewstate';

// Gap constants can be imported from booking config; using existing constant for V1/V2.
import { MIN_V1_V2_INTERVAL_DAYS, MIN_V3_V4_INTERVAL_DAYS } from 'config/booking';

export enum MeetingType {
  INFO = 'INFO',
  V0 = 'V0',
  V1V2 = 'V1V2',
  V3V4 = 'V3V4'
}

export type DayId = 'INFO' | 'V0' | 'V1' | 'V2' | 'V3' | 'V4';
export type ServiceKey = DayId; // alias for clarity

export interface MeetingDayConfig {
  id: DayId;              // logical day id e.g. INFO, V0, V1, V2, V3, V4
  serviceKey: ServiceKey;
  dependsOnPrev?: boolean; // if true, availability constrained by previous selection
  minGapDays?: number;     // minimal gap days between previous and this day
  weekendAdjust?: boolean; // move forward if resulting day is weekend
  exactGap?: boolean;      // require exact gap match (vs >=)
}

export interface MeetingTypeConfig {
  type: MeetingType;
  days: MeetingDayConfig[];
  needsContact: boolean; // whether email/phone form required
}

export const MEETING_TYPE_CONFIGS: Record<MeetingType, MeetingTypeConfig> = {
    [MeetingType.INFO]: {
        type: MeetingType.INFO,
        days: [{ id: 'INFO', serviceKey: 'INFO' }],
        needsContact: true,
    },
    [MeetingType.V0]: {
        type: MeetingType.V0,
        days: [{ id: 'V0', serviceKey: 'V0' }],
        needsContact: false,
    },
    [MeetingType.V1V2]: {
        type: MeetingType.V1V2,
        days: [
            { id: 'V1', serviceKey: 'V1' },
            { id: 'V2', serviceKey: 'V2', dependsOnPrev: true, minGapDays: MIN_V1_V2_INTERVAL_DAYS, weekendAdjust: true, exactGap: true },
        ],
        needsContact: false,
    },
    [MeetingType.V3V4]: {
        type: MeetingType.V3V4,
        days: [
            { id: 'V3', serviceKey: 'V3' },
            { id: 'V4', serviceKey: 'V4', dependsOnPrev: true, minGapDays: MIN_V3_V4_INTERVAL_DAYS, weekendAdjust: true, exactGap: true },
        ],
        needsContact: false,
    },
};

export const resolveMeetingType = (viewState: ViewState | null): MeetingType | null => {
    switch (viewState) {
    case ViewState.INFO_MEETING_BOOK_PAGE: return MeetingType.INFO;
    case ViewState.V0_MEETING_BOOK_PAGE: return MeetingType.V0;
    case ViewState.V1_MEETING_BOOK_PAGE: return MeetingType.V1V2;
    case ViewState.ACCESS_TO_DASHBOARD: return MeetingType.V3V4;
    default: return null;
    }
};
